import { useInView } from 'react-intersection-observer';

export const useInViewWithPrerender = (options: Parameters<typeof useInView>[0]) => {
    const inView = useInView({
        ...options,
        initialInView: (options && options.initialInView) || window.isPrerenderCrawler,
    });

    return inView;
};
